function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.833252,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#77A0C5",
    fillOpacity: 0.4,
    style: {
      fill: "#77A0C5",
      fill: "color(display-p3 0.4667 0.6275 0.7725)",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4693 21.52C22.3875 21.52 22.3029 21.4927 22.2484 21.4381C22.1121 21.3015 22.1121 21.0803 22.2211 20.9437C23.459 19.5945 24.1461 17.8328 24.1461 16.0137C24.1461 15.0222 23.9526 14.0854 23.5681 13.1786C23.4863 13.012 23.5681 12.7935 23.7617 12.7389C23.928 12.6569 24.1461 12.7389 24.2007 12.9328C24.6124 13.9243 24.8333 14.943 24.8333 16.0164C24.8333 18.0267 24.0916 19.9277 22.7446 21.4135C22.6356 21.4681 22.5511 21.5228 22.4693 21.5228V21.52Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0956 16.0409H18.0411C17.8475 16.0136 17.7112 15.847 17.7385 15.6558C17.8203 15.0768 17.9866 14.5005 18.1774 13.9487C18.232 13.7821 18.4528 13.6729 18.6164 13.7548C18.78 13.8094 18.8918 14.0307 18.81 14.1946C18.6164 14.6889 18.4801 15.2133 18.3983 15.7378C18.3983 15.9317 18.262 16.0409 18.0956 16.0409Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0036 13.3698C18.949 13.3698 18.8945 13.3424 18.84 13.3151C18.6736 13.2332 18.6191 13.012 18.7036 12.8481C18.7309 12.7661 18.7854 12.7115 18.84 12.6268C18.949 12.463 19.1426 12.4056 19.3062 12.5176C19.4698 12.6296 19.5271 12.8208 19.4153 12.9846C19.3608 13.0666 19.3335 13.1212 19.279 13.2059C19.2244 13.3151 19.1126 13.3725 19.0036 13.3725V13.3698Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1427 13.1485C19.1154 13.1485 19.0609 13.1485 19.0336 13.1212C19.0154 13.1212 18.9973 13.1121 18.9791 13.0939C18.8155 13.012 18.7037 12.818 18.7855 12.6542C18.8673 12.4903 19.0609 12.3783 19.2245 12.4602H19.2518C19.4154 12.5149 19.5271 12.7361 19.4453 12.9C19.4181 13.0666 19.2817 13.1485 19.1427 13.1485Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8094 10.5592C21.7276 10.5592 21.6458 10.5319 21.5886 10.4773C20.9014 9.87092 20.1053 9.43118 19.2518 9.128C19.0582 9.07338 18.9764 8.87946 19.031 8.68827C19.0855 8.49434 19.2791 8.4124 19.47 8.46703C20.4052 8.79752 21.2559 9.29189 22.0275 9.95286C22.1639 10.0894 22.1911 10.2834 22.0548 10.4472C22.0003 10.5019 21.9185 10.5565 21.8067 10.5565L21.8094 10.5592Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8639 13.6729H21.7821C20.8196 13.6729 19.9117 13.479 19.0064 13.1485C18.9246 13.1212 18.8428 13.0392 18.8128 12.9273C18.7856 12.818 18.7856 12.7333 18.8401 12.6241C19.5272 11.496 20.4897 10.5592 21.6431 9.89823C21.7794 9.81629 21.9185 9.8436 22.0275 9.92554C22.9628 10.7231 23.7044 11.7419 24.1707 12.8999C24.198 12.9819 24.198 13.0939 24.1707 13.1758C24.1162 13.2577 24.0616 13.3397 23.9498 13.3697C23.4836 13.5063 22.9873 13.591 22.4938 13.6183C22.2729 13.6456 22.0548 13.6729 21.8612 13.6729H21.8639ZM19.6635 12.6241C20.3507 12.8453 21.065 12.9546 21.7794 12.9546H21.834C22.0275 12.9546 22.2184 12.9546 22.412 12.9273C22.7419 12.8999 23.0446 12.8453 23.3472 12.7907C22.9628 11.9658 22.412 11.2475 21.7249 10.6166C20.956 11.1683 20.2143 11.8293 19.6635 12.6268V12.6241Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6532 22.9513C20.5441 22.9513 20.405 22.8966 20.3505 22.7846C20.2687 22.6208 20.3232 22.3995 20.4868 22.3176C21.0649 21.9871 21.6129 21.5474 22.0819 21.0503C21.8611 20.0315 21.3948 19.04 20.735 18.2152C20.5986 18.0513 20.4596 17.8847 20.3232 17.7208C19.6361 16.9779 18.8399 16.3988 17.932 16.0137C17.7684 15.9318 17.6838 15.7379 17.7684 15.5467C17.8502 15.3801 18.0438 15.2981 18.2346 15.3801C19.2244 15.8198 20.1051 16.4535 20.8468 17.2537C21.0104 17.4176 21.1494 17.6115 21.313 17.8055C22.0547 18.7696 22.5782 19.8976 22.8263 21.1104C22.8536 21.2196 22.8263 21.3316 22.7445 21.4135C22.1937 22.0199 21.5611 22.5142 20.8468 22.9294C20.765 22.9567 20.7104 22.9567 20.6532 22.9567V22.9513Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5101 14.4158C18.4556 14.4158 18.401 14.3885 18.3465 14.3612C18.1829 14.2793 18.1256 14.058 18.2102 13.8941C18.4038 13.591 18.5401 13.2332 18.6764 12.9027C18.731 12.7388 18.9518 12.6268 19.1154 12.7115C19.2817 12.7661 19.3908 12.9873 19.309 13.1512C19.1727 13.509 19.0064 13.8941 18.7855 14.2246C18.7582 14.3612 18.6219 14.4186 18.5101 14.4186V14.4158Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0854 13.1485C19.0582 13.1485 19.0036 13.1485 18.9764 13.1212C18.7828 13.0666 18.701 12.8727 18.7555 12.6815C19.0309 11.9112 19.1672 11.111 19.1672 10.2861C19.1672 9.87368 19.14 9.45852 19.0582 9.04609C18.3438 8.82485 17.6021 8.68829 16.8305 8.68829C16.1706 8.68829 15.5381 8.77023 14.9055 8.93684C14.7119 8.99146 14.521 8.88221 14.4938 8.68829C14.4392 8.49436 14.5483 8.30317 14.7419 8.27586C15.429 8.08193 16.1434 8 16.8578 8C17.7657 8 18.6437 8.16661 19.4972 8.43974C19.6062 8.46705 19.6907 8.5763 19.718 8.68829C19.8271 9.2127 19.8816 9.73438 19.8816 10.2588C19.8816 11.1683 19.7453 12.0478 19.4426 12.8754C19.3608 13.0693 19.2218 13.1513 19.0854 13.1513V13.1485Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8332 23.9973C15.2927 23.9973 13.8094 23.5575 12.5442 22.7299C12.3806 22.6207 12.3234 22.4268 12.4351 22.2629C12.5442 22.0963 12.7378 22.0416 12.9014 22.1536C14.0848 22.8965 15.4317 23.309 16.8332 23.309C17.9593 23.309 19.0609 23.0604 20.0507 22.5661C19.4726 22.0143 18.9791 21.3534 18.5946 20.6378C18.4856 20.4438 18.3738 20.2253 18.292 20.0041C17.853 19.0126 17.6321 17.9392 17.6321 16.8385C17.6321 16.5353 17.6594 16.2321 17.6867 15.929C17.5776 15.8743 17.4658 15.847 17.3567 15.8197C17.1631 15.7651 17.0813 15.5712 17.1359 15.38C17.1904 15.1861 17.384 15.1041 17.5749 15.1587C17.7957 15.2407 17.9866 15.3254 18.1802 15.4073C18.3165 15.4619 18.401 15.6285 18.3738 15.7651C18.3192 16.1229 18.292 16.4807 18.292 16.8385C18.292 17.8573 18.4856 18.8214 18.8973 19.731C18.9791 19.9249 19.0636 20.1161 19.1727 20.31C19.5844 21.0802 20.1625 21.7986 20.8223 22.3749C20.9041 22.4568 20.9586 22.5688 20.9314 22.678C20.9314 22.7873 20.8496 22.8993 20.7678 22.9539C19.6144 23.6149 18.2374 24 16.836 24L16.8332 23.9973Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4931 15.7924C17.4113 15.7924 17.3295 15.7651 17.2722 15.7105C17.1359 15.5739 17.1359 15.3527 17.2449 15.2161C17.6021 14.8037 17.932 14.3912 18.2074 13.9215C18.3438 13.591 18.4828 13.2878 18.6464 12.9846C17.932 12.6814 17.2722 12.2417 16.6669 11.7446C16.4733 11.5807 16.3097 11.4141 16.1434 11.2502C15.5108 10.6166 15.0173 9.87365 14.6328 9.04606C14.0002 9.23999 13.3949 9.54043 12.8469 9.89823C12.6833 10.0075 12.4624 9.95286 12.3806 9.78898C12.2715 9.6251 12.3261 9.40387 12.4897 9.32193C13.1768 8.85487 13.9457 8.52438 14.7446 8.30314C14.9082 8.24852 15.0745 8.33046 15.1563 8.49707C15.5135 9.34923 16.0098 10.0949 16.6669 10.7559C16.8305 10.9197 16.9695 11.059 17.1331 11.1956C17.7657 11.7473 18.4801 12.1598 19.249 12.4629C19.4126 12.5176 19.5244 12.7115 19.4426 12.9027C19.4153 12.9846 19.3881 13.0693 19.3608 13.1512C19.3608 13.1694 19.3517 13.1876 19.3335 13.2059C19.1399 13.509 19.0036 13.8668 18.8673 14.1973C18.8673 14.2155 18.8582 14.2337 18.84 14.2519C18.5374 14.7764 18.1802 15.2707 17.7684 15.7105C17.6866 15.7651 17.5749 15.7924 17.4931 15.7924Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1836 17.5268C15.0473 17.5268 14.9355 17.4449 14.881 17.3329C14.7992 17.169 14.881 16.9478 15.0446 16.8658C15.7044 16.5353 16.3097 16.1229 16.8578 15.6258C16.4461 15.5166 16.0043 15.4319 15.5654 15.4046C15.429 15.4046 15.3172 15.3773 15.1809 15.3773C14.9873 15.3773 14.851 15.2134 14.851 15.0195C14.851 14.8255 15.0146 14.689 15.2082 14.689C15.3445 14.689 15.4836 14.689 15.6199 14.7163C16.307 14.7709 16.9669 14.9102 17.5994 15.1287C17.7085 15.156 17.793 15.2653 17.8203 15.3773C17.8476 15.4865 17.8203 15.5985 17.7385 15.7077C17.0514 16.4507 16.2279 17.057 15.32 17.4968C15.2927 17.4968 15.2382 17.5241 15.1836 17.5241V17.5268Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35409 17.8573C9.18777 17.8573 9.05143 17.7481 9.02417 17.5814V17.5541C8.96963 17.3602 9.10597 17.1963 9.27229 17.1417C9.46588 17.0871 9.62948 17.2236 9.68402 17.4176V17.4449C9.71128 17.6388 9.60222 17.8027 9.40862 17.8573H9.35409Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7351 22.7873C12.6806 22.7873 12.5988 22.76 12.5416 22.7327C10.7283 21.5774 9.43591 19.7037 9.02146 17.5842C8.99419 17.4749 9.02145 17.3629 9.10325 17.281C9.10325 17.281 9.10326 17.2537 9.13052 17.2537C9.26685 17.1171 9.48771 17.1171 9.62404 17.2264C9.70584 17.3083 9.73311 17.4203 9.73311 17.5022C10.1176 19.2912 11.1891 20.9164 12.7024 21.9625C13.3077 21.2742 13.8013 20.504 14.1585 19.6764C14.2403 19.4824 14.3221 19.2639 14.4066 19.07C14.6274 18.4364 14.791 17.7754 14.8728 17.1144C14.9001 16.9205 15.0664 16.7839 15.2573 16.8112C15.4509 16.8385 15.5872 17.0051 15.5599 17.1963C15.4781 17.9119 15.3118 18.6275 15.0664 19.2885C14.9846 19.5098 14.9001 19.7283 14.791 19.9495C14.352 20.941 13.7467 21.8505 13.0051 22.648C12.896 22.7573 12.8115 22.7846 12.7297 22.7846L12.7351 22.7873Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35404 17.8573C9.32678 17.8573 9.27224 17.8573 9.24498 17.83H9.21771C9.10864 17.7754 9.02412 17.6935 8.99685 17.5815C8.88778 17.0571 8.83325 16.5354 8.83325 16.011C8.83325 13.3124 10.1802 10.8051 12.4351 9.34657C12.5715 9.26463 12.7651 9.26463 12.8741 9.40119C13.2859 9.81362 13.6703 10.2834 13.973 10.7778C14.1093 10.9717 14.2211 11.1902 14.3302 11.3841C14.9082 12.4029 15.2927 13.5036 15.4563 14.689C15.4835 14.7983 15.4835 14.9103 15.5108 15.0468C15.5381 15.2407 15.4017 15.4046 15.2081 15.4319C15.0146 15.4592 14.851 15.3227 14.8237 15.1288C14.8237 15.0195 14.7964 14.9075 14.7692 14.7983C14.6056 13.7249 14.2756 12.7061 13.7249 11.7419C13.6158 11.548 13.504 11.3568 13.3677 11.1629C13.1195 10.7778 12.8441 10.42 12.5442 10.0895C10.6192 11.4661 9.4931 13.6702 9.4931 16.0383C9.4931 16.478 9.54763 16.9478 9.60217 17.3876C9.6567 17.4695 9.6567 17.5514 9.62943 17.6634C9.6567 17.7454 9.52037 17.8573 9.35404 17.8573Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8844 18.2697C10.9764 18.2697 10.0984 18.1331 9.245 17.83C9.13593 17.8027 9.05141 17.6934 9.02414 17.5814C8.99687 17.4722 9.02414 17.3602 9.10594 17.2509C9.5722 16.7538 10.0684 16.3141 10.6465 15.9563C10.8401 15.8197 11.0582 15.7077 11.2791 15.5985C12.3779 15.0194 13.6431 14.689 14.9082 14.689H15.2109C15.3772 14.689 15.5136 14.8255 15.5408 14.9921C15.5408 15.1014 15.5681 15.2407 15.5681 15.3499C15.5954 15.5985 15.5954 15.817 15.5954 16.0655C15.5954 16.4507 15.5681 16.8358 15.5408 17.2209C15.5136 17.3301 15.459 17.4421 15.3472 17.4968C14.2484 17.9911 13.0923 18.267 11.8844 18.267V18.2697ZM10.0139 17.3356C10.6192 17.5022 11.2518 17.5842 11.8844 17.5842C12.9287 17.5842 13.9185 17.3629 14.8537 16.9505C14.881 16.6473 14.9082 16.3714 14.9082 16.0683C14.9082 15.847 14.9082 15.6285 14.881 15.4073V15.38C13.7276 15.4073 12.626 15.6832 11.5817 16.2048C11.3881 16.3141 11.1973 16.4261 11.0037 16.5353C10.6738 16.7839 10.3166 17.0324 10.0139 17.3329V17.3356Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7623 18.491C20.3779 18.491 20.0752 18.1878 20.0752 17.8027C20.0752 17.5542 20.2115 17.3357 20.4324 17.1964C20.5415 17.1418 20.6532 17.1144 20.7623 17.1144C21.1468 17.1144 21.4494 17.4176 21.4494 17.8027C21.4494 17.9693 21.3949 18.1059 21.2858 18.2425C21.1495 18.379 20.9559 18.491 20.7623 18.491Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5783 20.1981C14.4965 20.1981 14.442 20.1981 14.3575 20.1707C14.0821 20.0888 13.8912 19.8129 13.8912 19.5098C13.8912 19.1246 14.1939 18.8215 14.5783 18.8215C14.6874 18.8215 14.7719 18.8488 14.881 18.8761C15.1291 18.9853 15.2655 19.2339 15.2655 19.5098C15.2655 19.8949 14.9355 20.1981 14.5783 20.1981Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2655 15.7379H15.211C14.8538 15.7105 14.5784 15.4074 14.5784 15.0496C14.5784 14.7464 14.772 14.4705 15.0719 14.3886C15.1264 14.3613 15.2082 14.3613 15.2655 14.3613C15.6499 14.3613 15.9526 14.6644 15.9526 15.0496V15.1042C15.8981 15.4347 15.6227 15.7379 15.2655 15.7379Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7009 20.8863C18.3165 20.8863 18.0138 20.5831 18.0138 20.198C18.0138 19.8675 18.2619 19.5916 18.5918 19.5097H18.7009C19.0854 19.5097 19.388 19.8129 19.388 20.198C19.388 20.3919 19.3062 20.5831 19.1672 20.7224C19.0008 20.8317 18.8645 20.889 18.7009 20.889V20.8863Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6396 11.9358C16.2552 11.9358 15.9525 11.6327 15.9525 11.2476C15.9525 11.0536 16.0343 10.8898 16.1461 10.7532C16.2824 10.6166 16.4488 10.5593 16.6396 10.5593C17.0241 10.5593 17.3267 10.8624 17.3267 11.2476C17.3267 11.4114 17.2722 11.578 17.1604 11.6873C17.0241 11.8512 16.8305 11.9358 16.6369 11.9358H16.6396Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1393 14.0034C21.7548 14.0034 21.4521 13.7002 21.4521 13.3151C21.4521 12.93 21.7548 12.6268 22.1393 12.6268C22.4965 12.6268 22.7991 12.9027 22.8264 13.2605V13.3151C22.8264 13.7002 22.4965 14.0034 22.1393 14.0034Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1427 16.7566C10.9218 16.7566 10.7037 16.6473 10.5646 16.4534C10.4828 16.3442 10.4556 16.2049 10.4556 16.0683C10.4556 15.6832 10.7582 15.38 11.1427 15.38C11.3908 15.38 11.6389 15.5166 11.748 15.7378C11.8025 15.8471 11.8298 15.959 11.8298 16.0683C11.8298 16.4534 11.4999 16.7566 11.1427 16.7566Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8912 11.9358C13.5068 11.9358 13.2041 11.6327 13.2041 11.2476C13.2041 10.999 13.3404 10.7532 13.5613 10.6412C13.6431 10.5866 13.7822 10.5593 13.8912 10.5593C14.2757 10.5593 14.5783 10.8624 14.5783 11.2476C14.5783 11.4688 14.4693 11.6873 14.2757 11.8266C14.1666 11.8812 14.0275 11.9358 13.8912 11.9358Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.292a779ebf4609d192359964a33b0894.svg";
export { ForwardRef as ReactComponent };